<template>
  <div>
    <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
      <!-- Card stats -->
    </base-header>
    <BlockUI v-if="busy">
      <div class="loader"></div>
    </BlockUI>
    <div class="container-fluid mt--7 mb-5">
      <div class="row mb-3">
        <div class="col-12 col-md-12 col-xl-8 mb-3">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">แก้ไขร้านค้า</h3>
                </div>
              </div>
            </div>
            <template>
              <b-tabs active-nav-item-class="text-info">
                <b-tab
                  v-for="tab in tabTitle"
                  :key="tab.key"
                  @click="tabKey = tab.key"
                  class="py-3">
                  <template v-slot:title>
                    <div v-if="checkForm(tab.key)">
                      <i class="fas fa-check-circle fa-sm text-success"></i>
                      {{ tab.name }}
                    </div>
                    <div v-else>
                      <i class="far fa-check-circle fa-sm text-muted"></i>
                      {{ tab.name }}
                    </div>
                  </template>
                  <BrancePersonal
                    v-if="tab.key == 'personal'"
                    :submittEdit.sync="submittEdit"
                    :personal="personal"
                    @handleLoader="handleLoader()" />
                  <BranceUpgrade
                    v-if="tab.key == 'brance'"
                    :submittEdit.sync="submittEdit"
                    :brance="brance"
                    @handleLoader="handleLoader()"
                    @openModalConditionArea="conditionArea.show = true"
                    ref="brance" />
                  <BranceOther
                    v-if="tab.key == 'other'"
                    :submittEdit.sync="submittEdit"
                    :other="other"
                    @handleLoader="handleLoader()"
                    ref="other" />
                </b-tab>
              </b-tabs>
            </template>
          </card>
        </div>
        <div class="col-12 col-md-12 col-xl-4">
          <div class="row">
            <div class="col-12 mb-3" v-show="isAdmin() || isSuperAdmin()">
              <card shadow type="secondary">
                <div slot="header" class="bg-white border-0">
                  <div class="row align-items-center">
                    <div class="col-12">
                      <h3 class="mb-0">ยืนยันตัวตน</h3>
                    </div>
                  </div>
                </div>
                <div class="row p-3 mt-1 text-center">
                  <div class="col-4 pb-2 text-right">
                    <h3 class="mb-0">สถานะ:</h3>
                  </div>
                  <div class="col-8 pb-2 text-left">
                    <b-badge :variant="textStatusCommission.color + ' report'">
                      {{ textStatusCommission.status }}
                    </b-badge>
                  </div>
                  <div
                    class="col-4 pb-2 text-right"
                    v-if="userDetails && userDetails.date_time_confirm">
                    วันที่อนุมัติ:
                  </div>
                  <div
                    class="col-8 pb-2 text-center"
                    v-if="userDetails && userDetails.date_time_confirm">
                    {{ userDetails.date_time_confirm || "-" }}
                  </div>
                  <div class="col-12" v-if="isAdmin()">
                    <template
                      v-if="verify.status == '-2' || verify.status == '-3'">
                      <div class="row">
                        <div class="col-4 pb-2 text-right">
                          <h3 class="mb-0">เหตุผล:</h3>
                        </div>
                        <div class="col-8 pb-2 text-left">
                          <h4>{{ verify.remark }}</h4>
                        </div>
                      </div>
                    </template>
                  </div>
                  <div class="col-12 pb-2" v-if="isAdmin()">
                    <button
                      class="btn btn-info btn-block btn-icon py-2 mb-2"
                      @click="modal.verifyModal = true">
                      {{ textModalVerify.btnName }}
                    </button>
                  </div>
                  <div
                    class="col-12"
                    v-if="verify.status == '-2' || verify.status == '-3'">
                    <h4 class="text-muted">
                      หากคุณไม่ยืนยันตัวตน จะไม่ได้รับค่าคอมมิชชัน
                      ของรายการพัสดุที่เก็บเงินปลายทาง
                    </h4>
                  </div>
                  <div class="col-12" v-else-if="verify.status == '0'">
                    <h4 class="text-muted">
                      กรุณารอพนักงานตรวจสอบข้อมูล 1-3 วันทำการ
                    </h4>
                  </div>
                  <div class="col-12" v-else-if="verify.status == '-1'">
                    <h4 class="text-muted">
                      กรุณารอตรวจสอบจากตัวแทนจำหน่ายของคุณ
                    </h4>
                  </div>
                </div>
              </card>
            </div>
            <div class="col-12 mb-3" v-show="isSuperAdmin() || isShippop()">
              <card shadow type="secondary">
                <div slot="header" class="bg-white border-0">
                  <div class="row align-items-center">
                    <div class="col-12">
                      <h3 class="mb-0">เลือกขนส่งที่ต้องการเปิดใช้งาน</h3>
                    </div>
                  </div>
                </div>
                <div class="col-12 box-select-courier">
                  <b-form-group label="ประเภทขนส่งทั่วไป">
                    <b-form-checkbox-group
                      v-model="chkBoxCourier.selected"
                      :options="chkBoxCourier.courierGen"
                      class="mb-3"
                      value-field="id"
                      text-field="name"
                      disabled-field="notEnabled"
                      stacked
                      v-if="
                        chkBoxCourier.courierGen.length > 0
                      "></b-form-checkbox-group>
                    <h4 v-else>กรุณาสร้างขนส่ง</h4>
                  </b-form-group>
                </div>
              </card>
            </div>
            <div class="col-12 mb-3" v-if="!$USER_LOGIN.get().isAdmin">
              <card shadow type="secondary">
                <div slot="header" class="bg-white border-0">
                  <div class="row align-items-center">
                    <div class="col-12">
                      <h3 class="mb-0">การจัดการ</h3>
                    </div>
                  </div>
                </div>
                <div class="row p-3 mt-1" v-if="isSuperAdmin()">
                  <div class="col-6">
                    <button
                      class="btn btn-danger btn-block btn-icon py-3 mb-3"
                      v-if="isSuperAdmin() && status == 1"
                      @click="statusChange(0)">
                      <!-- <i class="far fa-file-alt"></i>  -->
                      ปิดใช้งาน
                    </button>
                    <button
                      class="btn btn-success btn-block btn-icon py-3 mb-3"
                      v-if="isSuperAdmin() && status == 0"
                      @click="statusChange(1)">
                      <!-- <i class="far fa-file-alt"></i>  -->
                      เปิดใช้งาน
                    </button>
                  </div>
                  <div class="col-6">
                    <button
                      class="btn btn-warning btn-block btn-icon py-3 mb-3"
                      v-if="isSuperAdmin()"
                      @click="model.paid = ''"
                      v-b-modal.modal-checkbill>
                      รับเงิน
                    </button>
                  </div>
                </div>
                <hr class="mb-2 mt-0" v-if="isSuperAdmin()" />
                <div class="row p-3 mt-1">
                  <div class="col-6">
                    <button
                      class="btn btn-info btn-block btn-icon py-3 mb-3"
                      @click="updateDataBrance">
                      <!-- <i class="fas fa-print"></i>  -->
                      บันทึก
                    </button>
                  </div>
                  <div class="col-6">
                    <button
                      class="btn btn-secondary btn-block btn-icon py-3 mb-3"
                      @click="getDataBrance">
                      <!-- <i class="fas fa-tachometer-alt"></i>  -->
                      คืนค่า
                    </button>
                  </div>
                </div>
              </card>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal คิดเงิน -->
    <b-modal
      centered
      no-close-on-backdrop
      no-close-on-esc
      ref="modal-checkbill"
      id="modal-checkbill"
      @hide="$bvModal.hide('modal-checkbill'), (model.paid = '')">
      <template slot="modal-title">
        <div slot="header" class="bg-white border-0">
          <div class="row align-items-center">
            <div class="col-12">
              <h3 class="mb-0">ข้อมูลการรับเงิน</h3>
            </div>
          </div>
        </div>
      </template>
      <card shadow type="secondary" class="m--4">
        <template>
          <form @submit.prevent>
            <div class>
              <div class="row">
                <div class="col-lg-12">
                  <div class="group-result">
                    <div class="price">
                      <h6>ยอดค้างชำระ</h6>
                      <h1>
                        {{ amount | numFormat("0,0.00") }}
                        <small>บาท</small>
                      </h1>
                    </div>
                  </div>
                  <hr class="my-4" />
                </div>
                <div class="col-lg-12">
                  <div class="price">
                    <div class="col-4 pl-0">
                      <h6>รับเงิน</h6>
                    </div>
                    <div class="col-8 pr-0">
                      <input
                        type="number"
                        class="form-control"
                        placeholder="0"
                        v-model="model.paid"
                        :class="{
                          'is-invalid': submittPaid && $v.model.paid.$error,
                        }" />
                      <div
                        v-if="submittPaid && !$v.model.paid.required"
                        class="invalid-feedback">
                        กรุณากรอกยอดเงินที่รับ
                      </div>
                      <div
                        class="error invalid-feedback"
                        v-if="!$v.model.paid.decimal">
                        กรุณากรอกเฉพาะ"ตัวเลข หรือ ทศนิยม"
                      </div>
                    </div>
                  </div>
                  <hr class="my-4" />
                </div>
                <div class="col-lg-12">
                  <div class="group-result">
                    <div class="price">
                      <h6>ยอดค้างชำระคงเหลือ</h6>
                      <h1 v-if="Number(model.paid) <= Number(amount)">
                        {{ (amount - model.paid) | numFormat("0,0.00") }}
                        <small>บาท</small>
                      </h1>
                      <h4 class="text-danger" v-else>
                        **กรุณาใส่ยอดเงินให้ถูกต้อง**
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </template>
      </card>
      <div slot="modal-footer" class="w-100 text-right">
        <b-button
          variant="secondary"
          @click="$bvModal.hide('modal-checkbill'), (model.paid = '')"
          >ยกเลิก</b-button
        >
        <b-button
          variant="success"
          v-if="Number(model.paid) <= Number(amount) && Number(model.paid) != 0"
          @click="paidDebt()"
          >ยืนยัน</b-button
        >
        <b-button variant="success" disabled v-else>ยืนยัน</b-button>
      </div>
    </b-modal>
    <b-modal
      id="modalEditAccount"
      hide-footer
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop
      title="แก้ไขบัญชี">
      <form @submit.prevent="updateAccount()">
        <card shadow type="secondary" class="m--4">
          <template>
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group mb-0">
                  <label>แก้ไข ชื่อ-สกุล</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="editAccount.name"
                    autocomplete="" />
                </div>
                <div
                  v-if="$v.editAccount.name.$error"
                  class="invalid-feedback d-block">
                  <span v-if="!$v.editAccount.name.required"
                    >กรุณากรอก ชื่อ - สกุล</span
                  >
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <div class="form-group mb-0">
                  <label>แก้ไข email</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="email"
                    v-model="editAccount.email"
                    autocomplete="" />
                </div>
                <div
                  v-if="$v.editAccount.email.$error"
                  class="invalid-feedback d-block">
                  <span v-if="!$v.editAccount.email.required"
                    >กรุณากรอกอีเมล์</span
                  >
                  <span v-if="!$v.editAccount.email.email"
                    >รูปแบบอีเมล์ไม่ถูกต้อง</span
                  >
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group mb-0">
                  <label>แก้ไข password</label>
                  <input
                    type="password"
                    class="form-control"
                    placeholder="password"
                    v-model="editAccount.password"
                    autocomplete="new-password" />
                </div>
                <div
                  v-if="$v.editAccount.password.$error"
                  class="invalid-feedback d-block">
                  <span v-if="!$v.editAccount.password.minLength"
                    >กรุณากรอก"รหัสผ่าน"อย่างน้อย
                    {{ $v.editAccount.password.$params.minLength.min }}
                    ตัวอักษร</span
                  >
                </div>
              </div>
            </div>
          </template>
        </card>
        <div slot="modal-footer" class="w-100 text-right pt-5">
          <b-button
            variant="secondary"
            @click="
              $bvModal.hide('modalEditAccount'),
                (editAccount.email = email),
                (editAccount.password = ''),
                (editAccount.name = editAccount.init.name)
            "
            >ยกเลิก</b-button
          >
          <b-button variant="success" type="submit">ยืนยัน</b-button>
        </div>
      </form>
    </b-modal>
    <verifyShop :modal="modal" :loading.sync="busy" :statusVerify="verify" />
    <ModalConditionArea :conditionArea="conditionArea" />
  </div>
</template>
<script>
import validatePop from "../plugins/validatePop.js";
import verifyShop from "@/components/custom/brance/VerifyShop";
import BrancePersonal from "@/components/custom/branceNew/BrancePersonal";
import BranceUpgrade from "@/components/custom/branceNew/BranceUpgrade";
import BranceArea from "@/components/custom/branceNew/BranceArea";
import BranceImages from "@/components/custom/branceNew/BranceImages";
import BranceOther from "@/components/custom/branceNew/BranceOther";
import { statusCommission } from "../plugins/statusCommission.js";
import ModalConditionArea from "@/components/custom/branceNew/ModalConditionArea";
import moment from "moment";
import configRegisterCommission from "@/config/RegisterCommission";
import {
  required,
  minLength,
  maxLength,
  numeric,
  email,
  decimal,
} from "vuelidate/lib/validators";
const API_URL = process.env.VUE_APP_API;
export default {
  name: "branceedit",
  components: {
    verifyShop,
    BrancePersonal,
    BranceUpgrade,
    BranceArea,
    BranceImages,
    BranceOther,
    ModalConditionArea,
  },
  data() {
    return {
      wallet: {
        status: false,
      },
      additional_service: {
        inter_parcel: 0,
      },
      submittEdit: false,
      submittPaid: false,
      modal: {
        verifyModal: false,
      },
      allowDropoffShippop: 0,
      verify: {
        status: null,
        remark: null,
      },
      conditionArea: {
        show: false,
        package: "",
      },
      busy: false,
      tabKey: "personal",
      personal: {
        ownerName: "",
        ownerNameEng: "",
        ownerTaxId: "",
        ownerTel: "",
        ownerEmail: "",
        ownerIdLine: "",
        saleName: "",
        saleTel: "",
        saleIdLine: "",
        saleId: null,
        listSale: [],
      },
      brance: {
        branceName: "",
        branceNameEng: "",
        companyName: "",
        branceTel: "",
        shopCode: "",
        dealerId: "",
        package: "",
        contractDate: "",
        serviceAreaCondition: "",
        natureBusiness: "",
        natureBusinessOther: "",
        lazadaDropoff: "",
        dhlDropoff: "",
        shippopDropoff: "",
        shopeeDropoff: "",
        doubleAFastPrint: "",
        kerryBranchId: "",
        kerryQuickBranchId: "",
        postcode: "",
        province: "",
        district: "",
        state: "",
        address: "",
        postcodeEng: "",
        provinceEng: "",
        districtEng: "",
        stateEng: "",
        addressEng: "",
        latitudeShop: "",
        longitudeShop: "",
        locationNear: [],
        closedDay: [],
        selectedCod: "1",
        selectTrial: null,
        dateExp: "",
        apiKey: "",
        member: "",
        countUser: "",
        linkGoogleMap: "",
      },
      area: {
        branceArea: "",
        storageSpace: "",
        storageSpaceFree: "",
        storageSpaceHeight: "",
        storageReng: "",
        storageRengFree: "",
        storageRengHeight: "",
        billboardReng: "",
        billboardRengFree: "",
        billboardRengLength: "",
        kitchenArea: "",
      },
      images: {
        frontArea: [],
        environmentArea: [],
        shopArea: [],
        storageSpace: [],
        tierShop: "",
        editImage: false,
      },
      other: {
        receipt: "",
        footerReceipt: "",
        sizeLabel: "A5",
        qrCode: "",
        cctv: "YES",
        scanner: "YES",
        parking: "YES",
        operationSystem: [],
        sellService: "YES",
        otherService: "YES",
        pickupTHP: "",
        timePickupTHP: null,
        numsOrderTHP: "",
        typeCarTHP: "",
      },
      userLogin: "",
      idBrance: "",
      email: "",
      detail: "",
      amount: "",
      status: "",
      allow_couriers: [],
      userDetails: {},
      editAccount: {
        init: {
          name: "",
        },
        id: 0,
        name: "",
        email: this.email,
        password: "",
        role: "admin",
      },
      chkBoxCourier: {
        selected: [],
        courierShippop: [],
        courierGen: [],
      },
      type_cod: [
        { value: "1", text: "ใช้งาน" },
        { value: "0", text: "ไม่ใช้งาน" },
      ],
      // modal PAY
      showBtnPaid: false,
      pay: "",
      model: {
        paid: "",
      },
      statusCommission: statusCommission,
    };
  },
  validations: {
    model: {
      paid: { required, decimal },
    },
    editAccount: {
      name: { required },
      email: { required, email },
      password: { minLength: minLength(6) },
    },
  },
  mounted() {
    this.userLogin = JSON.parse(localStorage.getItem("user"));
    if (this.isSuperAdmin() || this.isShippop()) {
      this.idBrance = this.$route.params.Id;
      this.getDataCouriers();
      this.getDataBrance();
    } else {
      this.idBrance = 0;
      this.getDataBrance();
    }
  },
  methods: {
    getDataBrance() {
      this.busy = true;
      this.$http
        .get(API_URL + "/shop/shop/" + this.idBrance, {
          headers: {
            Token: localStorage.getItem("access_token"),
          },
        })
        .then((res) => {
          let checkError = validatePop(res);
          if (!checkError.status) {
            this.busy = false;
            if (checkError.notices == "token is expired") {
              this.$router.push("/logout");
            }
            this.showErrorModal(checkError.msg);
            return false;
          }
          let results = res.data.data[0];
          this.email = results.email;
          this.editAccount.email = this.email;
          this.editAccount.id = results.users[0].id;
          this.editAccount.name = this.editAccount.init.name =
            results.users[0].name;
          this.amount = results.amount;
          this.idBrance = results.id;
          this.status = results.status;
          this.chkBoxCourier.selected = results.hasOwnProperty(
            "default_courier_shops"
          )
            ? results.default_courier_shops.map((data) => {
                return data.default_courier_id;
              })
            : "";
          results.expired_date == null
            ? (this.brance.dateExp = "กรุณาเลือกแพ็กเกจ")
            : (this.brance.dateExp = this.backEndDateFormat(
                results.expired_date
              ));
          this.conditionArea.package = results.package;
          this.busy = false;

          this.responseBrancePersonal(results);
          this.responseBranceShop(results);
          this.responseBranceArea(results);
          this.responseBranceImages(results);
          this.responseBranceOther(results);
          this.defaultBranceUpgrade();
          this.defaultBranceOther();
        });
    },
    responseBrancePersonal(results) {
      this.personal.ownerName = results.owner_name;
      this.personal.ownerNameEng = this.shopDetailsIsNotNull(results)
        ? results.shop_details.owner_name_eng
        : "";
      this.personal.ownerTaxId = results.tax_shop;
      this.personal.ownerTel = this.shopDetailsIsNotNull(results)
        ? results.shop_details.owner_tel
        : "";
      this.personal.ownerEmail = results.email;
      this.personal.ownerIdLine = this.shopDetailsIsNotNull(results)
        ? results.shop_details.id_line
        : "";
      this.personal.saleName = this.shopDetailsIsNotNull(results)
        ? results.shop_details.sale_support.name
        : "";
      this.personal.saleTel = this.shopDetailsIsNotNull(results)
        ? results.shop_details.sale_support.tel
        : "";
      this.personal.saleIdLine = this.shopDetailsIsNotNull(results)
        ? results.shop_details.sale_support.line_id
        : "";
      this.personal.saleId = this.shopDetailsIsNotNull(results)
        ? results.shop_details.sale_support.id
        : "";
      this.personal.listSale = results.list_sale_support
        ? results.list_sale_support
        : [];
    },
    responseBranceShop(results) {
      this.brance.branceName = results.name;
      this.brance.branceNameEng =
        this.shopDetailsIsNotNull(results) &&
        results.shop_details.name_eng != null
          ? results.shop_details.name_eng
          : "";
      this.brance.companyName = this.shopDetailsIsNotNull(results)
        ? results.shop_details.company_name
        : "";
      this.brance.branceTel = results.tel;
      this.brance.shopCode = results.shop_code;
      this.brance.dealerId = results.under_by.dealer_id;
      this.brance.package = results.package;
      this.brance.contractDate = this.shopDetailsIsNotNull(results)
        ? results.shop_details.contract_date
        : "";
      this.brance.serviceAreaCondition = this.shopDetailsIsNotNull(results)
        ? results.shop_details.service_area_condition
        : "";
      this.brance.natureBusiness = this.shopDetailsIsNotNull(results)
        ? results.shop_details.nature_business
        : "";
      if (
        !this.$refs.brance[0].natureBusiness.includes(
          this.brance.natureBusiness
        )
      ) {
        this.brance.natureBusinessOther = this.brance.natureBusiness;
        this.brance.natureBusiness = "อื่นๆ";
      }
      this.brance.lazadaDropoff = this.shopDetailsIsNotNull(results)
        ? results.shop_details.lazada_dropoff
        : "";
      this.brance.dhlDropoff = this.shopDetailsIsNotNull(results)
        ? results.shop_details.dhl_dropoff
        : "";
      this.brance.shopeeDropoff = this.shopDetailsIsNotNull(results)
        ? results.shop_details.shopee_dropoff
        : "";
      this.brance.shippopDropoff = this.shopDetailsIsNotNull(results)
        ? results.shop_details.shippop_dropoff
        : "";
      this.brance.doubleAFastPrint = this.shopDetailsIsNotNull(results)
        ? results.shop_details.double_a_fast_print
        : "";
      this.brance.kerryBranchId = this.shopDetailsIsNotNull(results)
        ? results.shop_details.kerry_branch_id
        : "";
      this.brance.kerryQuickBranchId = this.shopDetailsIsNotNull(results)
        ? results.shop_details.kerry_quick_branch_id
        : "";
      this.brance.address = results.address;
      this.brance.state = results.state;
      this.brance.district = results.district;
      this.brance.province = results.province;
      this.brance.postcode = results.postcode;
      this.brance.postcodeEng = this.shopDetailsIsNotNull(results)
        ? results.shop_details.postcode_eng
        : "";
      this.brance.provinceEng = this.shopDetailsIsNotNull(results)
        ? results.shop_details.province_eng
        : "";
      this.brance.districtEng = this.shopDetailsIsNotNull(results)
        ? results.shop_details.district_eng
        : "";
      this.brance.stateEng = this.shopDetailsIsNotNull(results)
        ? results.shop_details.state_eng
        : "";
      this.brance.addressEng = this.shopDetailsIsNotNull(results)
        ? results.shop_details.address_eng
        : "";
      this.brance.locationNear =
        this.shopDetailsIsNotNull(results) &&
        results.shop_details.location_near != null
          ? results.shop_details.location_near
          : [];
      this.brance.closedDay =
        this.shopDetailsIsNotNull(results) &&
        results.shop_details.closed_day != null
          ? results.shop_details.closed_day
          : [];
      this.brance.selectedCod = results.allow_cod;
      this.brance.apiKey = results.api_key;
      this.brance.countUser = results.users.length;
      this.brance.member = results.limited_member;
      this.brance.latitudeShop = this.shopDetailsIsNotNull(results)
        ? results.shop_details.latitude_shop > 0
          ? Number(results.shop_details.latitude_shop)
          : ""
        : "";
      this.brance.longitudeShop = this.shopDetailsIsNotNull(results)
        ? results.shop_details.longitude_shop > 0
          ? Number(results.shop_details.longitude_shop)
          : ""
        : "";
      this.brance.linkGoogleMap =
        "https://maps.google.com/?q=" +
        this.brance.latitudeShop +
        "," +
        this.brance.longitudeShop;
      if (this.brance.latitudeShop != "" && this.brance.longitudeShop != "") {
        this.$refs.brance[0].center.lat = this.brance.latitudeShop;
        this.$refs.brance[0].center.lng = this.brance.longitudeShop;
      }
    },
    responseBranceArea(results) {
      this.area.branceArea = this.shopDetailsIsNotNull(results)
        ? results.shop_details.area_shop
        : "";
      this.area.storageSpace = this.shopDetailsIsNotNull(results)
        ? results.shop_details.storage_space
        : "";
      this.area.storageSpaceFree = this.shopDetailsIsNotNull(results)
        ? results.shop_details.storage_space_meters
        : "";
      this.area.storageSpaceHeight = this.shopDetailsIsNotNull(results)
        ? results.shop_details.storage_space_height
        : "";
      this.area.storageReng = this.shopDetailsIsNotNull(results)
        ? results.shop_details.storage_rent
        : "";
      this.area.storageRengFree = this.shopDetailsIsNotNull(results)
        ? results.shop_details.storage_rent_meters
        : "";
      this.area.storageRengHeight = this.shopDetailsIsNotNull(results)
        ? results.shop_details.storage_rent_height
        : "";
      this.area.billboardReng = this.shopDetailsIsNotNull(results)
        ? results.shop_details.billboard_rent
        : "";
      this.area.billboardRengFree = this.shopDetailsIsNotNull(results)
        ? results.shop_details.billboard_rent_meters
        : "";
      this.area.billboardRengLength = this.shopDetailsIsNotNull(results)
        ? results.shop_details.billboard_rent_length
        : "";
      this.area.kitchenArea = this.shopDetailsIsNotNull(results)
        ? results.shop_details.kitchen_area
        : "";
    },
    responseBranceImages(results) {
      this.images.frontArea =
        this.shopDetailsIsNotNull(results) &&
        results.shop_details.image_shop != null &&
        results.shop_details.image_shop.hasOwnProperty("front_area")
          ? results.shop_details.image_shop.front_area
          : [];
      this.images.environmentArea =
        this.shopDetailsIsNotNull(results) &&
        results.shop_details.image_shop != null &&
        results.shop_details.image_shop.hasOwnProperty("environment_area")
          ? results.shop_details.image_shop.environment_area
          : [];
      this.images.shopArea =
        this.shopDetailsIsNotNull(results) &&
        results.shop_details.image_shop != null &&
        results.shop_details.image_shop.hasOwnProperty("shop_area")
          ? results.shop_details.image_shop.shop_area
          : [];
      this.images.storageSpace =
        this.shopDetailsIsNotNull(results) &&
        results.shop_details.image_shop != null &&
        results.shop_details.image_shop.hasOwnProperty("storage_space")
          ? results.shop_details.image_shop.storage_space
          : [];
      this.images.tierShop = results.tier_shop;
    },
    responseBranceOther(results) {
      this.other.receipt = results.detail;
      this.other.footerReceipt = results.footer_receipt;
      this.other.sizeLabel = results.default_label_size;
      this.other.qrCode = results.qrcode_receipt;
      this.other.cctv = this.shopDetailsIsNotNull(results)
        ? results.shop_details.cctv
        : "";
      this.other.scanner = this.shopDetailsIsNotNull(results)
        ? results.shop_details.barcode_scanner
        : "";
      this.other.parking = this.shopDetailsIsNotNull(results)
        ? results.shop_details.parking
        : "";
      this.other.operationSystem =
        this.shopDetailsIsNotNull(results) &&
        results.shop_details.operating_system != null
          ? results.shop_details.operating_system
          : [];
      this.other.sellService = this.shopDetailsIsNotNull(results)
        ? results.shop_details.sell_service
        : "";
      this.other.otherService = this.shopDetailsIsNotNull(results)
        ? results.shop_details.other_service
        : "";
      this.other.pickupTHP = this.shopDetailsIsNotNull(results)
        ? results.shop_details.pickup_thp
        : "";
      this.other.timePickupTHP = this.shopDetailsIsNotNull(results)
        ? results.shop_details.time_pickup_thp
        : "";
      this.other.numsOrderTHP = this.shopDetailsIsNotNull(results)
        ? results.shop_details.nums_order_thp
        : "";
      this.other.typeCarTHP = this.shopDetailsIsNotNull(results)
        ? results.shop_details.type_car_thp
        : "";
    },
    shopDetailsIsNotNull(shop) {
      return shop.shop_details != null;
    },
    checkAlert() {
      let res = [];
      this.tabTitle.forEach((item, index) => {
        res[index] = this.checkForm(item.key);
      });
      return Object.values(res).every((val) => val == true);
    },
    checkForm(type) {
      let res = false;
      let data = {};
      if (type == "personal") {
        Object.keys(this.personal).forEach((key) => {
          if (["ownerName", "ownerNameEng", "ownerTel"].includes(key)) {
            data[key] = this.personal[key];
          }
        });
      } else if (type == "brance") {
        Object.keys(this.brance).forEach((key) => {
          if (
            [
              "branceName",
              "branceNameEng",
              "branceTel",
              "natureBusiness",
              "address",
              "addressEng",
              "state",
              "stateEng",
              "district",
              "districtEng",
              "province",
              "provinceEng",
              "postcode",
              "postcodeEng",
              "latitudeShop",
              "longitudeShop",
              "locationNear",
              "closedDay",
            ].includes(key)
          ) {
            data[key] = this.brance[key];
          }
        });
      } else if (type == "area") {
        data = this.area;
      } else if (type == "images") {
        Object.keys(this.images).forEach((key) => {
          if (["environmentArea", "frontArea", "shopArea"].includes(key)) {
            data[key] = this.images[key] ? this.images[key] : [];
          }
        });
        res = Object.values(data).every((val) => val.length > 0);
      } else if (type == "other") {
        Object.keys(this.other).forEach((key) => {
          if (
            [
              "cctv",
              "scanner",
              "parking",
              "operationSystem",
              "sellService",
              "otherService",
            ].includes(key)
          ) {
            data[key] = this.other[key];
          }
        });
      }
      if (type != "images") {
        res = Object.values(data).every((val) => val != "" || val.length > 0);
      }
      return res;
    },
    updateDataBrance() {
      this.submittEdit = true;
      this.submittEdit ? (this.model.paid = 0) : "";
      this.busy = true;
      this.$http
        .put(
          API_URL + "/shop/shop/" + this.idBrance,
          {
            owner_name: this.personal.ownerName,
            owner_tel: this.personal.ownerTel,
            tax_shop: this.personal.ownerTaxId,
            name: this.brance.branceName,
            tel: this.brance.branceTel,
            address: this.brance.address,
            state: this.brance.state,
            district: this.brance.district,
            province: this.brance.province,
            postcode: this.brance.postcode,
            detail: this.other.receipt,
            footer_receipt: this.other.footerReceipt,
            qrcode_receipt: this.other.qrCode,
            allow_couriers: this.chkBoxCourier.selected,
          },
          {
            headers: { Token: localStorage.getItem("access_token") },
          }
        )
        .then((res) => {
          let checkError = validatePop(res);
          this.submittEdit = false;
          if (!checkError.status) {
            this.busy = false;
            this.showErrorModal(checkError.msg);
            return false;
          }
          this.showSuccessModal("แก้ไขข้อมูลร้านค้า");
          this.getDataBrance();
        });
    },
    updateAccount() {
      this.busy = true;
      this.$v.editAccount.$touch();
      if (this.$v.editAccount.$invalid) {
        this.busy = false;
        return false;
      }
      this.$http
        .put(
          API_URL + "/shop/member/" + this.editAccount.id,
          {
            name: this.editAccount.name,
            email: this.editAccount.email,
            password: this.editAccount.password,
            role: this.editAccount.role,
          },
          {
            headers: { Token: localStorage.getItem("access_token") },
          }
        )
        .then((res) => {
          let checkError = validatePop(res);
          if (!checkError.status) {
            this.busy = false;
            this.showErrorModal(checkError.msg);
            return false;
          }
          this.$bvModal.hide("modalEditAccount");
          this.showSuccessModal("แก้ไขสมาชิกเสร็จสิ้น");
          this.editAccount = {
            init: {
              name: "",
            },
            id: 0,
            name: "",
            email: "",
            password: "",
            role: "admin",
          };
          this.getDataBrance();
          this.busy = false;
        });
    },
    getDataCouriers() {
      this.$http
        .get(API_URL + "/shop/superadmin/couriers", {
          headers: {
            Token: localStorage.getItem("access_token"),
          },
        })
        .then((res) => {
          let checkError = validatePop(res);
          if (!checkError.status) {
            if (checkError.notices == "token is expired") {
              this.$router.push("/logout");
            }
            this.showErrorModal(checkError.msg);
            return false;
          }
          this.chkBoxCourier.courierShippop = res.data.data.filter(
            (courier) => {
              courier.name = courier.name + " " + courier.description;
              return (
                courier.is_shippop == 1 &&
                (courier.expired_date == null ||
                  new Date(courier.expired_date).getTime() >=
                    new Date().getTime())
              );
            }
          );
          this.chkBoxCourier.courierGen = res.data.data.filter((courier) => {
            return courier.is_shippop == 0;
          });
        });
    },
    backEndDateFormat(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    paidDebt() {
      this.submittPaid = true;
      this.$v.model.$touch();
      if (this.$v.model.$invalid) {
        return false;
      }
      this.$http
        .put(
          API_URL + `/admin/shop/${this.idBrance}/clearbill`,
          {
            cash: this.model.paid,
          },
          {
            headers: { Token: localStorage.getItem("access_token") },
          }
        )
        .then((res) => {
          let checkError = validatePop(res);
          if (!checkError.status) {
            this.showErrorModal(checkError.msg);
            return false;
          }
          this.submittPaid = false;
          this.model.paid = "";
          this.$refs["modal-checkbill"].hide();
          this.showSuccessModal("ชำระเงินเสร็จสิ้น");
          this.getDataBrance();
        });
    },
    statusChange(status) {
      this.$http
        .put(
          API_URL + `/admin/shop/${this.idBrance}/status`,
          {
            status: status,
          },
          {
            headers: { Token: localStorage.getItem("access_token") },
          }
        )
        .then((res) => {
          let checkError = validatePop(res);
          if (!checkError.status) {
            this.showErrorModal(checkError.msg);
            return false;
          }
          this.showSuccessModal("แก้ไขสถานะร้านค้าเสร็จสิ้น");
          this.getDataBrance();
        });
    },
    stripTag(originalString) {
      return originalString.replace(/(<([^>]+)>)/gi, "");
    },
    defaultBranceUpgrade() {
      this.brance.locationNear.forEach((location) => {
        this.$refs.brance[0].$refs[Object.keys(location)][0].value =
          location[Object.keys(location)];
        let index = this.$refs.brance[0].optionsLocationNear.findIndex(
          (option) => {
            return option.key == Object.keys(location);
          }
        );
        if (index > -1) {
          this.$refs.brance[0].optionsLocationNear[index].item[
            Object.keys(location)
          ] = location[Object.keys(location)];
        }
      });

      this.brance.closedDay.forEach((day) => {
        this.$refs.brance[0].open[Object.keys(day)] =
          day[Object.keys(day)]["open"];
        this.$refs.brance[0].close[Object.keys(day)] =
          day[Object.keys(day)]["close"];

        let index = this.$refs.brance[0].optionsClosedDay.findIndex(
          (option) => {
            return option.key == Object.keys(day);
          }
        );

        if (index > -1) {
          this.$refs.brance[0].optionsClosedDay[index].item[
            Object.keys(day)
          ].open = day[Object.keys(day)]["open"];
          this.$refs.brance[0].optionsClosedDay[index].item[
            Object.keys(day)
          ].close = day[Object.keys(day)]["close"];
        }
      });
    },
    defaultBranceOther() {
      this.other.operationSystem.forEach((system) => {
        if (typeof system === "object" && system !== null) {
          this.$refs.other[0].$refs[Object.keys(system)][0].value =
            system[Object.keys(system)];
          let index = this.$refs.other[0].optionsOperationSystem.findIndex(
            (option) => {
              return option.key == Object.keys(system);
            }
          );
          if (index > -1) {
            this.$refs.other[0].optionsOperationSystem[index].item[
              Object.keys(system)
            ] = system[Object.keys(system)];
          }
        }
      });
    },
    handleLoader() {
      this.busy = !this.busy;
    },
    isAdmin() {
      return this.userLogin.role === "admin";
    },
    isSuperAdmin() {
      return this.userLogin.role === "superadmin";
    },
    isShippop() {
      return this.userLogin.role === "shippop";
    },
    showSuccessModal(msgBody) {
      this.$bvModal.msgBoxOk(msgBody, {
        title: "SUCCESS",
        size: "sm",
        buttonSize: "sm",
        okVariant: "success",
        okTitle: "ตกลง",
        contentClass: "modal-success",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true,
      });
    },
    showErrorModal(msgBody) {
      this.$bvModal.msgBoxOk(msgBody, {
        title: "ERROR",
        size: "sm",
        buttonSize: "sm",
        okVariant: "danger",
        okTitle: "ลองอีกครั้ง",
        contentClass: "modal-errors",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true,
      });
    },
    isShow() {
      let response = false;
      if (this.isSuperAdmin() || this.isShippop()) {
        response = true;
      }
      return response;
    },
  },
  computed: {
    textModalVerify() {
      let res = {
        btnName: "",
      };
      const status = configRegisterCommission.statusRegister;

      if ([String(null), null].includes(this.verify.status)) {
        res.btnName = "ยืนยันตัวตน";
      } else if (
        [status.REJECT_BY_SP, status.REJECT_BY_SA].includes(this.verify.status)
      ) {
        res.btnName = "อัพเดทข้อมูล";
      } else {
        res.btnName = "ดูข้อมูลที่ยืนยันตน";
      }

      return res;
    },
    textStatusCommission() {
      return this.statusCommission(this.verify.status);
    },
    tabTitle() {
      return [
        { key: "personal", name: "ข้อมูลส่วนตัว" },
        { key: "brance", name: "ข้อมูลร้าน" },
        { key: "other", name: "อื่นๆ" },
      ];
    },
  },
};
</script>
<style lang="scss" scoped>
.report {
  color: #212529;
  font-size: 1.1rem;
  width: 100%;
}
</style>
